<template lang="pug">
.match
  input#match(v-model="match", type="checkbox", value="true")
  label(for="match") 
    span Add Delay Match (additional $20 charge)
</template>


<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "SelectorMatch",
  computed: {
    ...mapGetters(["model"]),
    match: {
        get() {            
        return this.model.match || "";
      },
        set(value) {            
        this.setModel({ parameter: "match", value });
      },
    },
  },
  methods: {
    ...mapMutations(["setModel"]),
  },
};
</script>

<style lang="scss" scoped>
.match {
  display: flex;
  margin: 0;
  position: relative;

  input {
    @include hideVisually;

    &:checked + label::before {
      color: inherit;
    }
  }

  label {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 0.875rem;
    cursor: pointer;

    &::before {
      content: "\e906";
      display: flex;
      justify-content: center;
      align-items: center;
      height: 1.125rem;
      width: 1.125rem;
      color: transparent;
      border: 1px solid $midGray;
      font-family: "icomoon" !important;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      font-size: 0.875rem;
      transition: 0.15s ease;

      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
}
</style>